const initialState = {
    dataDatasets: false,
    dataDataset: false,
    dataDatasetGroup: false,
    dataTags: false,
    dataDetailDataset: false,

    dataSpasialMetadataArcgis: false,
    dataSpasialMetadataXmlArcgis: false,
    dataSpasialTabelArcgis: false,


    dataSpasialGeoserver: false,
    dataSpasialMetadataGeoserver: false,
    dataSpasialMetadataXmlGeoserver: false,
    dataSpasialTabelGeoserver: false,

    dataSpasialShp: false,
    dataSpasialMetadataXmlShp: false,
    dataSpasialTabelShp: false,

    dataSpasialGeoJson: false,
    dataSpasialTabelGeoJson: false,

    dataTabelJson: false,

    totResultDatasets: 0,
    totPageDatasets: 0,

    dataGrafikAxisA: false,
    dataGrafikAxisB: false,
    dataGrafikResult: false
}

const datasetReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'DATA_DATASETS':
            return { ...state, dataDatasets: action.payload }
        case 'DATA_DATASET':
            return { ...state, dataDataset: action.payload }
        case 'DATA_DATASET_GROUP':
            return { ...state, dataDatasetGroup: action.payload }
        case 'DATA_TAGS':
            return { ...state, dataTags: action.payload }
        case 'DATA_DETAIL_DATASET':
            return { ...state, dataDetailDataset: action.payload }
        case 'DATA_SPASIAL_METADATA_ARCGIS':
            return { ...state, dataSpasialMetadataArcgis: action.payload }
        case 'DATA_SPASIAL_METADATA_XML_ARCGIS':
            return { ...state, dataSpasialMetadataXmlArcgis: action.payload }
        case 'DATA_SPASIAL_TABEL_ARCGIS':
            return { ...state, dataSpasialTabelArcgis: action.payload }
        case 'DATA_SPASIAL_GEOSERVER':
            return { ...state, dataSpasialGeoserver: action.payload }
        case 'DATA_SPASIAL_METADATA_GEOSERVER':
            return { ...state, dataSpasialMetadataGeoserver: action.payload }
        case 'DATA_SPASIAL_METADATA_XML_GEOSERVER':
            return { ...state, dataSpasialMetadataXmlGeoserver: action.payload }
        case 'DATA_SPASIAL_TABEL_GEOSERVER':
            return { ...state, dataSpasialTabelGeoserver: action.payload }
        case 'DATA_SPASIAL_SHP':
            return { ...state, dataSpasialShp: action.payload }
        case 'DATA_SPASIAL_METADATA_XML_SHP':
            return { ...state, dataSpasialMetadataXmlShp: action.payload }
        case 'DATA_SPASIAL_TABEL_SHP':
            return { ...state, dataSpasialTabelShp: action.payload }
        case 'DATA_SPASIAL_GEOJSON':
            return { ...state, dataSpasialGeoJson: action.payload }
        case 'DATA_SPASIAL_TABEL_GEOJSON':
            return { ...state, dataSpasialTabelGeoJson: action.payload }
        case 'DATA_TABEL_JSON':
            return { ...state, dataTabelJson: action.payload }
        case 'TOT_RESULT_DATASETS':
            return { ...state, totResultDatasets: action.payload }
        case 'TOT_PAGE_DATASETS':
            return { ...state, totPageDatasets: action.payload }
        case 'DATA_GRAFIK_AXIS_A':
            return { ...state, dataGrafikAxisA: action.payload }
        case 'DATA_GRAFIK_AXIS_B':
            return { ...state, dataGrafikAxisB: action.payload }
        case 'DATA_GRAFIK_RESULT':
            return { ...state, dataGrafikResult: action.payload }
        default:
            return state
    }
}

export default datasetReducer;